export const validateLongitude = (input: string): boolean => {
  const lonRegex = /^-?(180(\.0+)?|1[0-7]\d(\.\d+)?|[1-9]?\d(\.\d+)?)$/;

  return lonRegex.test(input);
};
